function debounce(fn, delay) {
    var timeoutID = null
    return function () {
        clearTimeout(timeoutID)
        var args = arguments
        var that = this
        timeoutID = setTimeout(function () {
            fn.apply(that, args)
        }, delay)
    }
}

function getUserDetails(user) {
    if (user && user.signInUserSession && user.signInUserSession.idToken.payload)
        return user.getSignInUserSession().getIdToken().payload;
}

async function getOnlineUserAttributes(user) {
    return new Promise((resolve, reject) => {
        user.getUserAttributes(function (err, result) {
            if (err)
                reject(err);
            else
                resolve(result);
        })
    });
}

function generateRandomPassword(length = 12) {
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!-_.:;?[]{}()/&%$#@=\\';
    let randPwd = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
        randPwd += charset.charAt(Math.floor(Math.random() * n));
    }
    return randPwd;
}

function detectLanguage() {
    return navigator.language || navigator.userLanguage;
}

function capitalize(value) {
    return value[0].toUpperCase() + value.slice(1);
}

function removeFromArray(item, array) {
    const index = array.indexOf(item);
    if (index > -1) {
        array.splice(index, 1);
    }
}

export default {
    capitalize,
    debounce,
    detectLanguage,
    getUserDetails,
    getOnlineUserAttributes,
    generateRandomPassword,
    removeFromArray
}